import { BaseService } from './base.service';

export default class EquipmentSharingService extends BaseService {
  public async sendEquipmentInvitation(
    invitation_type: 'owner_to_manager' | 'manager_to_athlete' | 'owner_transfer',
    email: string,
    equipment_id?: number
  ) {
    return this.axios.post(`${this.backendUrl}/v2/equipment-invitations`, {
      invitation_type,
      email,
      ...(equipment_id != null ? { equipment_id } : {}),
    });
  }

  public async acceptInvitation(invitationId: number) {
    return this.axios.post(`${this.backendUrl}/v2/equipment-invitations/${invitationId}/accept`, {});
  }

  public async declineInvitation(invitationId: number) {
    return this.axios.delete(`${this.backendUrl}/v2/equipment-invitations/${invitationId}/decline`);
  }

  public async getAthleteManagers() {
    return this.axios.get(`${this.backendUrl}/v2/equipment/managers`);
  }

  public async revokeAthleteManager(managerId: number) {
    return this.axios.delete(`${this.backendUrl}/v2/equipment/managers/${managerId}`);
  }

  public async getSentEquipmentInvitations() {
    return this.axios.get(`${this.backendUrl}/v2/equipment-invitations`);
  }

  public async cancelEquipmentInvitation(invitationId: number) {
    return this.axios.delete(`${this.backendUrl}/v2/equipment-invitations`, {
      data: { invitation_id: invitationId },
    });
  }

  public async hideEquipmentFromManager(equipmentId: number, managerId: number) {
    return this.axios.post(`${this.backendUrl}/v2/equipment/${equipmentId}/managers/${managerId}/hide`, {});
  }

  public async unhideEquipmentForManager(equipmentId: number, managerId: number) {
    return this.axios.delete(`${this.backendUrl}/v2/equipment/${equipmentId}/managers/${managerId}/hide`);
  }
}
